const AUTO_ADVANCE = {
  OFF: {
    label:       'Off',
    submitValue: 0,
  },
  SEC3: {
    label:       '3secs',
    submitValue: 3000,
  },
  SEC5: {
    label:       '5sec',
    submitValue: 5000,
  },
  SEC7: {
    label:       '7sec',
    submitValue: 7000,
  },
};

AUTO_ADVANCE.ALL = _.values(AUTO_ADVANCE);

export default AUTO_ADVANCE;
